<nz-layout class="h-[100vh] bg-white overflow-y-auto">
  <nz-header class="p-0 h-24">
    <app-admin-header slug="system"></app-admin-header>
  </nz-header>

  <nz-content class="">
    <router-outlet></router-outlet>
  </nz-content>
</nz-layout>